// src/pages/JobView.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { MapPin, Briefcase, IndianRupee, Wallet } from 'lucide-react';
import '../../styles/JobsPage/jobsview.css';
import JobApplyPopup from './JobApplyPopup'; // ✅ Ensure this path is correct

const JobView = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const res = await fetch(`http://localhost:3000/api/jobs/${jobId}`);
        if (!res.ok) throw new Error('Failed to fetch job');
        const data = await res.json();
        setJob(data);
      } catch (err) {
        setError('Job not found or server error');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchJob();
  }, [jobId]);

  if (loading) {
    return (
      <div className="job-view-page">
        <h2></h2>
      </div>
    );
  }

  if (error || !job) {
    return (
      <div className="job-view-page">
        <h2>{error || 'Job not found'}</h2>
      </div>
    );
  }

  return (
    <div className="job-view-page">
      <div className="job-container">
        <button onClick={() => navigate(-1)} className="jobview-back-button">← Back to listings</button>

        <div className="job-header">
          <div className="job-info">
            <h1 className="job-title">{job.title}</h1>
            <h3 className="company-name">{job.company}</h3>

            <div className="job-meta">
              <span className="meta-item"><MapPin size={16} /> {job.location}</span>
              <span className="meta-item"><Briefcase size={16} /> {job.experience} years</span>
              <span className="meta-item">
                {job.salary ? (
                  <>
                    <IndianRupee size={16} /> {job.salary}
                  </>
                ) : (
                  <>
                    <Wallet size={16} /> Not specified
                  </>
                )}
              </span>
            </div>
          </div>

          <div className="job-actions">
            {job.logo && (
              <img src={job.logo} alt="Company Logo" className="company-logo" />
            )}
            <button className="apply-btn" onClick={() => setShowModal(true)}>
              Apply Now
            </button>
          </div>
        </div>

        <hr className="separator-line" />

        <div className="skills-section">
          <h2>Skills Required</h2>
          <div className="skills">
            {job.skills?.map((skill, idx) => (
              <span key={idx} className="skill-tag">{skill}</span>
            ))}
          </div>

          <hr className="separator-line" />

          <div className="job-description">
            <h2>Job Description</h2>
            <div className="job-description-text">
              {job.description?.split('\n').map((line, index) => {
                const trimmed = line.trim();
                if (trimmed === '') return <br key={index} />;

                const match = trimmed.match(/^\*\*(.+?):\*\*\s*(.*)/);
                if (match) {
                  return (
                    <p key={index}>
                      <strong>{match[1]}:</strong> {match[2]}
                    </p>
                  );
                }

                return <p key={index}>{trimmed}</p>;
              })}
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Job Application Modal */}
      {showModal && (
        <JobApplyPopup
          jobTitle={job.title}
          jobId={job._id} 
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default JobView;
